import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Layout from '../containers/layout-container/Layout.js';
import { hasSectionAccess, getDefaultRoute } from '../config/rolePermissions';

const ProtectedRoute = ({
  ChildComponent,
  isPrivateRoute = true,
  ...props
}) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const role = useSelector((state) => state.auth.role);
  const location = useLocation();

  if (isPrivateRoute && !isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (!isPrivateRoute && isAuthenticated) {
    return <Navigate to="/" />;
  }

  // Role-based section gating: an authenticated user whose role isn't allowed to
  // see this page is bounced to their default landing section.
  if (
    isPrivateRoute &&
    isAuthenticated &&
    !hasSectionAccess(role, location.pathname)
  ) {
    return <Navigate to={getDefaultRoute(role)} replace />;
  }

  return <Layout ChildComponent={ChildComponent} {...props} />;
};

export default ProtectedRoute;
